// src/navigationSlice.js
import { createSlice } from "@reduxjs/toolkit";

const captainRole = process.env.REACT_APP_CAPTAIN_ID;
const adminRole = process.env.REACT_APP_ADMIN_ROLE;
const managerRole = process.env.REACT_APP_MANAGER_ROLE;
const financeRole = process.env.REACT_APP_FINANCE_ROLE;
const operatorRole = process.env.REACT_APP_OPERATOR_ROLE;
const rentalPartnerRole = process.env.REACT_APP_PARTNER_ROLE;
const clientRole = process.env.REACT_APP_CLIENT_ROLE;

const initNav = [
  {
    name: "Dashboard",
    href: "/",
    icon: "HomeIcon",
    current: true,
    showFilter: false,
    showFilter: false,
    allowedroles: [adminRole, managerRole, financeRole],
  },
  {
    name: "Vehicles",
    href: "/vehicles",
    icon: "TruckIcon",
    current: false,
    showFilter: false,
    showFilter: false,
    allowedroles: [adminRole, managerRole, financeRole, operatorRole, rentalPartnerRole],
  },
  {
    name: "Drivers",
    href: "/customers",
    icon: "UsersIcon",
    current: false,
    allowedroles: [adminRole, managerRole, financeRole, clientRole],
  },
  {
    name: "Reservations",
    href: "/reservations",
    icon: "BookOpenIcon",
    current: false,
    showFilter: false,
    allowedroles: [
      captainRole,
      adminRole,
      managerRole,
      financeRole,
      financeRole,
      operatorRole,
      rentalPartnerRole,
      clientRole
    ],
  },
  {
    name: "Partners",
    href: "/rental-partners",
    icon: "UsersIcon",
    allowedroles: [adminRole],
  },
  {
    name: "Users",
    href: "/users",
    icon: "UserCircleIcon",
    current: false,
    showFilter: false,
    allowedroles: [adminRole],
  },
  {
    name: "Smart-Bill",
    href: "/smart-bill",
    icon: "BanknotesIcon",
    current: false,
    showFilter: false,
    allowedroles: [adminRole],
  },
  {
    name: "Companies",
    href: "/companies",
    icon: "BuildingOfficeIcon",
    current: false,
    showFilter: false,
    allowedroles: [adminRole, managerRole, financeRole, clientRole],
  },
  {
    name: "Branches & fleets",
    href: "#",
    icon: "MapPinIcon",
    current: false,
    showFilter: false,
    allowedroles: [adminRole, rentalPartnerRole],
    subItems: [
      {
        name: "Branches",
        href: "/branches",
        current: false,
        allowedroles: [adminRole, rentalPartnerRole],
      },
      {
        name: "Fleet locations",
        href: "/fleetlocations",
        current: false,
        showFilter: false,
        allowedroles: [adminRole],
      },
    ],
  },


  {

    name: "Finance",
    href: "#",
    icon: "ChartBarIcon",
    current: false,
    showFilter: false,
    allowedroles: [adminRole, financeRole],
    subItems: [
      {
        name: "General Reports",
        href: "/reports",
        current: false,
        allowedroles: [adminRole, financeRole],
      },
      {
        name: "Account Statement",
        href: "/account-statement",
        current: false,
        allowedroles: [adminRole, financeRole],
      }
    ]
  },
];

const settingNav = [

  {
    name: "Cities",
    href: "/cities",
    icon: "MapIcon",
    current: false,
    showFilter: false,
    allowedroles: [adminRole, managerRole, financeRole],
  },
  {
    name: "Vehicle Settings",
    href: "#",
    icon: "TruckIcon",
    current: false,
    showFilter: false,
    allowedroles: [adminRole, managerRole, financeRole],
    subItems: [
      {
        name: "Types",
        href: "/vehicletypes",
        current: false,
        showFilter: false,
        allowedroles: [adminRole, managerRole, financeRole],
      },
      {
        name: "Brands",
        href: "/vehiclebrands",
        current: false,
        showFilter: false,
        allowedroles: [adminRole, managerRole, financeRole],
      },
      {
        name: "Models",
        href: "/vehiclemodels",
        current: false,
        showFilter: false,
        allowedroles: [adminRole, managerRole, financeRole],
      },
      {
        name: "Vehicle categories",
        href: "/vehicleclasses",
        current: false,
        showFilter: false,
        allowedroles: [adminRole, managerRole, financeRole],
      },
      {
        name: "Colors",
        href: "/colors",
        current: false,
        showFilter: false,
        allowedroles: [adminRole, managerRole, financeRole],
      },
      {
        name: "Damage types",
        href: "/damagetypes",
        current: false,
        showFilter: false,
        allowedroles: [adminRole, managerRole, financeRole],
      },
    ],
  },
  {
    name: "Extras",
    href: "#",
    icon: "SquaresPlusIcon",
    current: false,
    showFilter: false,
    allowedroles: [adminRole, managerRole, financeRole],
    subItems: [
      {
        name: "Extras categories",
        href: "/addoncategories",
        current: false,
        showFilter: false,
        allowedroles: [adminRole, managerRole, financeRole],
      },
      {
        name: "Extras",
        href: "/addons",
        current: false,
        allowedroles: [adminRole, managerRole, financeRole],
      },
      {
        name: "Mileage options",
        href: "/mileageoptions",
        current: false,
        showFilter: false,
        allowedroles: [adminRole, managerRole, financeRole],
      },
      {
        name: "Coverage options",
        href: "/coverageoptions",
        current: false,
        showFilter: false,
        allowedroles: [adminRole, managerRole, financeRole],
      },
    ],
  },
  {
    name: "Seasons",
    href: "/seasons",
    icon: "SunIcon",
    current: false,
    showFilter: false,
    allowedroles: [adminRole, managerRole, financeRole],
  },
  {
    name: "Rates",
    href: "#",
    icon: "ReceiptPercentIcon",
    current: false,
    showFilter: false,
    allowedroles: [adminRole, managerRole, financeRole],
    subItems: [
      {
        name: "Vehicle rates",
        href: "/vehiclerates",
        current: false,
        showFilter: false,
        allowedroles: [adminRole, managerRole, financeRole],
      },
      {
        name: "Extras rates",
        href: "/extrasrates",
        current: false,
        showFilter: false,
        allowedroles: [adminRole, managerRole, financeRole],
      },
      {
        name: "Mileage options rates",
        href: "/mileageoptionsrates",
        current: false,
        showFilter: false,
        allowedroles: [adminRole, managerRole, financeRole],
      },
      {
        name: "Coverage options rates",
        href: "/coverageoptionsrates",
        current: false,
        showFilter: false,
        allowedroles: [adminRole, managerRole, financeRole],
      },
      {
        name: "Delivery rates",
        href: "/deliveryrates",
        current: false,
        showFilter: false,
        allowedroles: [adminRole, managerRole, financeRole],
      },
    ],
  },

  {
    name: "Currencies",
    href: "#",
    icon: "CurrencyDollarIcon",
    current: false,
    showFilter: false,
    allowedroles: [adminRole],
    subItems: [
      {
        name: "Currencies",
        href: "/currencies",
        current: false,
        showFilter: false,
        allowedroles: [adminRole],
      },
      {
        name: "Currency exchanges",
        href: "/currencyexchanges",
        current: false,
        showFilter: false,
        allowedroles: [adminRole],
      },
    ],
  },
  {
    name: "General",
    href: "/general-settings",
    icon: "Cog6ToothIcon",
    current: false,
    showFilter: false,
    allowedroles: [adminRole, managerRole],
  },
];
const initialState = {
  navigation: setCurrentFlagFromURL(initNav),
  isSettings: isMenu(settingNav),
  settingsRolesAllowed: [adminRole, managerRole, financeRole],
};

function hasAnyCurrentTrue(item) {
  if (item.current) {
    return true;
  }

  if (item.subItems) {
    for (const subItem of item.subItems) {
      if (subItem.current) {
        return true;
      }
    }
  }

  return false;
}

function hasAnyCurrentTrueInNavigation(navigation) {
  for (const item of navigation) {
    if (hasAnyCurrentTrue(item)) {
      return true;
    }
  }
  return false;
}

function traverseMenu(items) {
  const currentPath = window.location.pathname;

  return items.map((item) => {
    const newItem = {
      ...item,
      current: item.href === currentPath,
    };

    if (newItem.subItems) {
      newItem.subItems = traverseMenu(newItem.subItems);
      newItem.current =
        newItem.subItems && newItem.subItems.some((subItem) => subItem.current);
    }

    return newItem;
  });
}

function isMenu(menuItems) {
  const currentPath = window.location.pathname;

  if (currentPath == "/") {
    return false;
  }

  const value = traverseMenu(menuItems);

  return hasAnyCurrentTrueInNavigation(value) ? true : false;
}

function setCurrentFlagFromURL(menuItems) {
  const currentPath = window.location.pathname;

  if (currentPath == "/") {
    return initNav;
  }

  const value = traverseMenu(menuItems);
  const settingValue = traverseMenu(settingNav);

  return hasAnyCurrentTrueInNavigation(settingValue) ? settingValue : value;
}

const navigationSlice = createSlice({
  name: "navigation",
  initialState,
  reducers: {
    updateNavigation: (state, action) => {
      const { navigation } = action.payload;
      state.navigation = navigation;
      //state.isSettings = isMenu(settingNav);
    },
    setSettingsNav: (state, action) => {
      state.navigation = settingNav;
      state.isSettings = true;
    },
    resetNav: (state, action) => {
      state.navigation = initNav;
      state.isSettings = false;
    },
  },
});

export const { updateNavigation, setSettingsNav, resetNav } =
  navigationSlice.actions;

// Export navigation arrays for use in other components
export { initNav, settingNav };

export default navigationSlice.reducer;
